var zIndex = {
  zIndex__2: -2,
  zIndex__1: -1,
  zIndex_0: 0,
  zIndex_1: 50,
  // surface
  zIndex_2: 100,
  // surface content
  zIndex_3: 200,
  // status bar
  zIndex_4: 300,
  // app/site globals
  zIndex_5: 400,
  // app/site globals content
  zIndex_6: 500,
  // floating masthead
  zIndex_7: 600,
  // body containers
  zIndex_8: 700,
  // content
  zIndex_9: 800,
  // floating content
  zIndex_10: 900,
  // above content
  zIndex_11: 1000,
  // overlays
  zIndex_12: 1100,
  // modals
  zIndex_13: 1200,
  // above modals
  zIndex_14: 1300 // alerts
};
export default zIndex;